module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-campany-basicpolicy-963c6b8c5640094ad3c56cdde61c4747.svg";